import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { LANG_STORAGE_KEY, t as translate } from '../i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem(LANG_STORAGE_KEY) || null;
    } catch {
      return null;
    }
  });

  const setLang = useCallback((next) => {
    const value = next === 'kn' ? 'kn' : 'en';
    setLangState(value);
    try {
      localStorage.setItem(LANG_STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
  }, []);

  const needsSelection = !lang;

  const t = useCallback((key) => translate(lang || 'en', key), [lang]);

  const value = useMemo(
    () => ({ lang: lang || 'en', setLang, needsSelection, t, hasPreference: Boolean(lang) }),
    [lang, setLang, needsSelection, t]
  );

  useEffect(() => {
    document.documentElement.lang = lang === 'kn' ? 'kn' : 'en';
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
